import { render } from "./FileUploadField.vue?vue&type=template&id=2af022f5"
import script from "./FileUploadField.vue?vue&type=script&lang=js"
export * from "./FileUploadField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__